<template>
  <div class="bbread" >
    <div v-if="position.macrofamily && width > 576 && position.cod_macrofamiglia !== '4TOOLS' && position.cod_macrofamiglia !== '4CLEAN'">
      <span >
        <img :src="url('/media/icons/svg/caret-left-black.svg')" alt="left arrow">
      </span>
      <span>
        <a :href="url('/catalog/' + position.cod_macrofamiglia)">{{ position.macrofamily.descrizione }}</a>
      </span>
    </div>
    <div v-if="position.family">
      <span>
        <img :src="url('/media/icons/svg/caret-left-black.svg')" alt="left arrow">
      </span>
      <span v-if="(getPath === 'family') && (position.cod_macrofamiglia === '4CLEAN' || position.cod_macrofamiglia === '4TOOLS')">
        <a :href="url('/')">Home</a>
      </span>
      <span v-else>
        <a :href="url('/catalog/' + position.cod_macrofamiglia + '/family/' + position.family.codice)">{{ position.family.descrizione }}</a>
      </span>
    </div>
    <div v-if="position.color && elemento">
      <span>
        <img :src="url('/media/icons/svg/caret-left-black.svg')" alt="left arrow">
      </span>
      <span class="catcolor">
         <cod-elm :elm="position"/>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "breadcrumb",
  components: {},
  props: {
    elemento: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      position: this.$store.state.breadcrumb,
      width: window.innerWidth
    }
  },
  mounted() {
  },
  computed: {
    getPath(){
      let path = window.location.pathname
      path = path.split('/')
      return path[path.length - 2]
    }
  }
}
</script>

<style lang="scss" scoped>
.bbread {
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }
  display: flex;
  color: var(--text-white);
  margin-right: 20px;
  margin-bottom: 20px;
  width: 120%;
  @media (max-width: 576px) {
    margin-right: 0;
  }
div {
  span {
    display: inline-block;
    margin-right: 10px;
    text-transform: lowercase;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  span img {
    display: inline-block;
    height: 14px;
    filter: invert(1);
  }
  .catcolor {
    .cod_element {
      text-transform: uppercase;
    }
  }
}

}

</style>
